import React, { createContext, useEffect, useState } from 'react';
import { useAccount } from 'wagmi';
import { ethers } from 'ethers'; // Import ethers
import TombFinance from '../../tomb-finance';
import config from '../../config';

export interface TombFinanceContext {
  tombFinance?: TombFinance;
}

interface TombFinanceProviderProps {
  children?: React.ReactNode;
}

export const Context = createContext<TombFinanceContext>({ tombFinance: null });

export const TombFinanceProvider = ({ children }: TombFinanceProviderProps) => {
  // Manually create the provider using ethers
  const provider = typeof window !== "undefined" && window.ethereum 
    ? new ethers.providers.Web3Provider(window.ethereum) 
    : null;

  const { address } = useAccount();
  const [tombFinance, setTombFinance] = useState<TombFinance>();

  useEffect(() => {
    if (!tombFinance) {
      const tomb = new TombFinance(config);
      if (address && provider) {
        // wallet was unlocked at initialization
        tomb.unlockWallet(provider, address);
      }
      setTombFinance(tomb);
    } else if (address && provider) {
      tombFinance.unlockWallet(provider, address);
    }
  }, [address, provider, tombFinance]);

  const hasChildren = React.Children.count(children) > 0;

  return (
    <Context.Provider value={{ tombFinance }}>
      {hasChildren ? <>{children}</> : null}
    </Context.Provider>
  );
};

TombFinanceProvider.defaultProps = {
  children: null,
};
